<div id="dashboard-merchant-table">
  <p-table
    #dt
    [value]="rows ?? []"
    [paginator]="(rows?.length ?? 0) > 0"
    [rows]="10"
    [rowsPerPageOptions]="[5, 10, 25]"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} merchants"
    [globalFilterFields]="['merchantName']"
    dataKey="merchantId"
    sortField="merchantName"
    [sortOrder]="1"
    [rowHover]="true"
    styleClass="p-datatable-striped p-datatable-sm"
    data-cy="dashboard-merchant-table"
  >
    <ng-template pTemplate="caption">
      <div class="table-caption">
        <span class="table-title">MERCHANTS</span>
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            (input)="dt.filterGlobal($any($event.target).value, 'contains')"
            placeholder="Search merchant"
            data-cy="dashboard-merchant-search"
          />
        </span>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="merchantName" class="name-col" pTooltip="Merchant Name" tooltipPosition="top">
          Name <p-sortIcon field="merchantName"></p-sortIcon>
        </th>
        <th pSortableColumn="transactions" class="num" pTooltip="Transactions" tooltipPosition="top">
          Txns <p-sortIcon field="transactions"></p-sortIcon>
        </th>
        <th pSortableColumn="amountTotal" class="num" pTooltip="Amount Total" tooltipPosition="top">
          Amnt Total <p-sortIcon field="amountTotal"></p-sortIcon>
        </th>
        <th pSortableColumn="pctCustMember" class="num" pTooltip="% Customers Member" tooltipPosition="top">
          % Cust. Mbr <p-sortIcon field="pctCustMember"></p-sortIcon>
        </th>
        <th pSortableColumn="pctTxnsMember" class="num" pTooltip="% Transactions Member" tooltipPosition="top">
          % Txns Mbr <p-sortIcon field="pctTxnsMember"></p-sortIcon>
        </th>
        <th pSortableColumn="amountTotalMember" class="num" pTooltip="Member Spend" tooltipPosition="top">
          Mbr $ <p-sortIcon field="amountTotalMember"></p-sortIcon>
        </th>
        <th pSortableColumn="members" class="num" pTooltip="Members" tooltipPosition="top">
          Mbrs <p-sortIcon field="members"></p-sortIcon>
        </th>
        <th pSortableColumn="avgMemberSpend" class="num" pTooltip="Average Member Spend" tooltipPosition="top">
          Avg Mbr $ <p-sortIcon field="avgMemberSpend"></p-sortIcon>
        </th>
        <th pSortableColumn="transactionsMember" class="num" pTooltip="Member Transactions" tooltipPosition="top">
          Mbr Txns <p-sortIcon field="transactionsMember"></p-sortIcon>
        </th>
        <th pSortableColumn="avgMemberTxn" class="num" pTooltip="Average Member Transaction" tooltipPosition="top">
          Avg Mbr Txn <p-sortIcon field="avgMemberTxn"></p-sortIcon>
        </th>
        <th pSortableColumn="amountTotalNonMember" class="num" pTooltip="Non-Member Spend" tooltipPosition="top">
          Non-Mbr $ <p-sortIcon field="amountTotalNonMember"></p-sortIcon>
        </th>
        <th pSortableColumn="nonMembers" class="num" pTooltip="Non-Members" tooltipPosition="top">
          Non-Mbrs <p-sortIcon field="nonMembers"></p-sortIcon>
        </th>
        <th pSortableColumn="avgNonMemberSpend" class="num" pTooltip="Average Non-Member Spend" tooltipPosition="top">
          Avg Non-Mbr $ <p-sortIcon field="avgNonMemberSpend"></p-sortIcon>
        </th>
        <th
          pSortableColumn="transactionsNonMember"
          class="num"
          pTooltip="Non-Member Transactions"
          tooltipPosition="top"
        >
          Non-Mbr Txns <p-sortIcon field="transactionsNonMember"></p-sortIcon>
        </th>
        <th
          pSortableColumn="avgNonMemberTxn"
          class="num"
          pTooltip="Average Non-Member Transaction"
          tooltipPosition="top"
        >
          Avg Non-Mbr Txn <p-sortIcon field="avgNonMemberTxn"></p-sortIcon>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
      <tr (click)="onRowSelect(row)" class="merchant-row" data-cy="dashboard-merchant-row">
        <td class="name-col" [pTooltip]="row.merchantName" tooltipPosition="top">{{ row.merchantName }}</td>
        <td class="num">{{ row.transactions | number }}</td>
        <td class="num money">{{ row.amountTotal | currency }}</td>
        <td class="num">{{ row.pctCustMember | percent }}</td>
        <td class="num">{{ row.pctTxnsMember | percent }}</td>
        <td class="num money">{{ row.amountTotalMember | currency }}</td>
        <td class="num">{{ row.members | number }}</td>
        <td class="num money">{{ row.avgMemberSpend | currency }}</td>
        <td class="num">{{ row.transactionsMember | number }}</td>
        <td class="num money">{{ row.avgMemberTxn | currency }}</td>
        <td class="num money">{{ row.amountTotalNonMember | currency }}</td>
        <td class="num">{{ row.nonMembers | number }}</td>
        <td class="num money">{{ row.avgNonMemberSpend | currency }}</td>
        <td class="num">{{ row.transactionsNonMember | number }}</td>
        <td class="num money">{{ row.avgNonMemberTxn | currency }}</td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="15">No merchants found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
